import { all } from 'redux-saga/effects'
import mediaSagas from 'app/store/effects/media'
import teacherGuideSagas from 'app/store/effects/teacher-guide.saga'
import userDataSagas from 'app/store/effects/user-data.saga'

export default function* rootSaga() {
  yield all([...mediaSagas, teacherGuideSagas(), userDataSagas()])
}
